import React from 'react';
import styles from './formsBrowser.module.scss';
import { getFormsByFilter } from './services/formsBrowserService';
import { Form } from './Form';
import { FilterProps, FormProps, SelectionProps } from './types/FormTypes';

export const FormsHomeGallery = React.memo(
    (props: { selectionProps: SelectionProps; filterProps: FilterProps }) => {
        try {
            const {
                selectionProps,
                selectionProps: { allForms },
                filterProps: {
                    categoryFilterSelected,
                    departmentFilterSelected,
                },
            } = props;

            return (
                <div className={styles.formsGalleryViewContainer}>
                    <div className={styles.formsGalleryViewSubContainer}>
                        {getFormsByFilter(
                            categoryFilterSelected,
                            departmentFilterSelected,
                            allForms,
                        )?.map((form: FormProps, index: number) => (
                            <div key={index}>
                                <Form
                                    form={form}
                                    selectionProps={selectionProps}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            );
        } catch {
            return null;
        }
    },
);
